import type { ReactNode } from "react";
import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api.js";

/**
 * Candidate · "prefer a human?" affordance (POST /invite/{token}/interview/human).
 * Available once a session exists (check-in and interview steps); routes to a recruiter.
 */
export function RequestHuman({ token }: { token: string }): ReactNode {
  const req = useMutation({
    mutationFn: () => api.post<unknown>(`/invite/${token}/interview/human`),
  });

  if (req.isSuccess) {
    return (
      <span className="mut sm" style={{ fontWeight: 600, color: "var(--good)" }}>
        ✓ Request sent — a recruiter will follow up with you
      </span>
    );
  }
  return (
    <button className="btn ghost sm" disabled={req.isPending} onClick={() => req.mutate()}>
      {req.isPending ? "Sending…" : "Prefer a human interview? Request one"}
    </button>
  );
}
